import React from 'react';

import { RequestAddPatient, PrivateLayout } from '../components';
import { ROUTE_PATHS } from '../utils';

export const AddPatientView = () => {
  return (
    <PrivateLayout
      pageTitle='add patient'
      pageIcon={<i className='fa-light fa-user-injured me-2'></i>}
      breadcrumbs={[{ label: 'Back to patient list', href: ROUTE_PATHS.patients }]}>
      <RequestAddPatient />
    </PrivateLayout>
  );
};
